import { render, staticRenderFns } from "./ssoLogin.vue?vue&type=template&id=acba9fca&scoped=true"
import script from "./ssoLogin.vue?vue&type=script&lang=js"
export * from "./ssoLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acba9fca",
  null
  
)

export default component.exports